import React, { useEffect, useState } from 'react'
import View from '../../atoms/view'
import TextField from '../textField'
import { P } from '@modul-connect/shared/components/atoms/text'
import theme from '../../../theme'


export const CustomModal = ({ openModal, addTeam, onClose, orgname, disabled, addingFailed, teamAlreadyExist }) => {
  const S = styles()
  const [name, setName] = useState('')
  const [errorName, setErrorName] = useState(false)
  const [teamPosted, setTeamPosted] = useState(false)
  const [selectedOrg, setSelectedOrg] = useState(null)

  useEffect(() => {
    if (openModal) {
      setName('')
      setErrorName(false)
      setTeamPosted(false)
    }
  }, [openModal])
  
  useEffect(() => {
    if(openModal && ( teamAlreadyExist)) {
      setErrorName(true)
    }
  }, [teamAlreadyExist])
  
  const onSave = () => {
    if (!name.trim()) {
      setErrorName(true)
      return
    }
  
    const teamData = {
      name: name.trim(),
      parentId: selectedOrg
    }
  
  
    addTeam(teamData)
    setTeamPosted(true)
    setSelectedOrg(null)
  
  }

  const trimName = name?.trim()
  
  return (
    <View extend={S.background_overlay}>
      <View extend={S.modal_container}>
        <View extend={S.modal_header}>
          <View extend={S.text_title}>{'Create team'}</View>
        </View>
        <View extend={S.modal_body}>
          {teamPosted && addingFailed && (
            <P noPadding style={{ color: theme.color.error }}>
            Adding team failed. (Server error)
            </P>
          )}
    
          {teamPosted && teamAlreadyExist && (
            <P noPadding style={{ color: theme.colors.error }}>
            Team already exists.
            </P>
          )}
    
          <TextField icon='Pencil2' placeholder={'Name'} extend={S.modal_input} error={errorName} onChange={(e) => {
            setName(e.target.value)
            setErrorName(false)
          }}/>
          <View extend={S.modal_devider}></View>
          <View extend={S.modal_buttons}>
            <View extend={S.save_button({ disabled: !trimName })} onClick={!trimName ? undefined : onSave}>
              <View extend={() => S.button_text({ isCancel: false })}>{'Save'}</View>
            </View>
            <View extend={S.cancel_button} onClick={onClose}>
              <View extend={() => S.button_text({ isCancel: true })}>{'Cancel'}</View>
            </View>
          </View>
        </View>
      </View>
    </View>
  )
}

/* ───────────────────────────── Styles ───────────────────────────── */

const styles = () => ({
  background_overlay: () => ({
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.36)', 
    zIndex: 999, 
  }),
  modal_container: () => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '0px 0px 24px',
    gap: '16px',
    position: 'absolute',
    transform: 'translate(-50%, -50%)',
    left: '50%',
    top: '50%',
    width: '463px',
    minHeight: '195px',
    background: '#FFFFFF',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.08)',
    borderRadius: '4px',
    zIndex: 10,
    
  }),
  modal_header: () => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    padding: '12px 24px',
    gap: '4px',
    width: '463px',
    height: '46px',
    background: '#EDEDED'
  }),
  text_title: () => ({
    width: '415px',
    height: '22px',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '22px'
  }),
  modal_body: () => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '0px 24px',
    gap: '16px',
    width: '463px',
    minHeight: '109px',
    flex: 'none',
    order: 1,
    alignSelf: 'stretch',
    flexGrow: 0
  }),
  modal_input: () => ({
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '8px 12px',
    gap: '16px',
    width: '415px',
    height: '36px',
    border: '1px solid #CACACA',
    marginBottom: 0,
    borderRadius: '4px',
    flex: 'none',
    order: 0,
    alignSelf: 'stretch',
    flexGrow: 0,
    backgroundColor: 'transparent'
  }),
  modal_devider: () => ({
    width: '415px',
    height: '0px',
    border: '1px solid #D5D5D5',
    flex: 'none',
    order: 1,
    alignSelf: 'stretch',
    flexGrow: 0
  }),
  modal_buttons: () => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '0px',
    width: '415px',
    height: '41px',
    flex: 'none',
    order: 2,
    alignSelf: 'stretch',
    flexGrow: 0,
    gap: 10
  }),
  save_button: ({ disabled }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '8px 66px',
    gap: '10px',
    width: '169px',
    height: '35px',
    background: disabled ? '#494949' : theme.colors.buttonBackground,
    borderRadius: '4px',
    flex: 'none',
    order: 0,
    flexGrow: 0,
    cursor: disabled ? 'default' : 'pointer'
  }),
  button_text: ({ isCancel }) => ({
    width: isCancel ? '53px' : '37px',
    height: '19px',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '19px',
    color: isCancel ? '#404040' : '#FDFDFD',
    flex: 'none',
    order: 0,
    flexGrow: 0
  }),
  cancel_button: ({ theme }) => ({
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '8px 20px',
    gap: '12px',
    width: '93px',
    height: '35px',
    border: '1px solid #404040',
    borderRadius: '4px',
    flex: 'none',
    order: 1,
    flexGrow: 0,
    cursor: 'pointer'
  })



})
